module.exports = __webpack_public_path__ + "img/reject.ef3e1c6a.svg";